/* eslint-disable no-irregular-whitespace */
import { css } from '@emotion/react';
import { PageProps } from 'gatsby';
import { ContactSection } from '@/components/general/ContactSection';
import { Layout } from '@/components/general/Layout';
import { PageHeader } from '@/components/general/PageHeader';
import { Seo } from '@/components/general/Seo';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="利用規約"
      description="【Uniforce】IPO準備クラウドの利用規約。個人情報の取り扱いやその他のご利用に関する規約を掲載しています。"
    />
    <section>
      <PageHeader
        en="SERVICE POLICY"
        title="利用規約"
        subTitle="Uniforceサービス利用規約"
      />
      <div
        css={css`
          margin-top: 40px;
          max-width: 820px;
          margin: 0 auto;
          padding: 0 30px;

          @media ${getScreen('pc')} {
            margin-top: 56px;
          }
        `}
      >
        <p
          css={css`
            font: normal normal normal 14px/20px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.28px;
            color: #2b2c40;
            border-bottom: 1px solid #d1d8dd;
            padding-bottom: 24px;
            margin-bottom: 24px;

            @media ${getScreen('pc')} {
              font: normal normal normal 14px/24px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.28px;
              padding-bottom: 40px;
              margin-bottom: 40px;
            }
          `}
        >
          本規約は、Uniforce株式会社（旧：株式会社start-up
          studio。以下「当社」といいます）とお客様との間での、当社が提供する「Uniforce」の利用条件を定めるものです。お客様は、本サービスをご使用する前に、本規約の全文をお読みください。
        </p>
        <div
          css={css`
            color: #2b2c40;

            h2 {
              font: normal normal 500 16px/24px 'Noto Sans JP', sans-serif;
              text-align: center;
              margin-top: 40px;
            }
            
            h3 {
              font: normal normal 500 16px/24px 'Noto Sans JP', sans-serif;
              letter-spacing: 0px;
              color: #2b2c40;
              margin: 24px 0 8px;

              &:first-of-type {
                margin-top: 0;
              }
            }

            ol {
              font: normal normal normal 14px/20px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.28px;
              color: #2b2c40;
            }
            ol.i_2em {
              padding-left: 2em;
              li {
                text-indent: -2em;
                
                & > ol {
                  margin-left: -2em;
                }
              }
            }
            ol.i_3em {
              padding-left: 3em;
              li {
                text-indent: -3em;
                
                & > ol {
                  margin-left: -3em;
                }
              }
            }
            
            p {
              font: normal normal normal 14px/20px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.28px;
              color: #2b2c40;
              text-indent: 1em;
            }
            
            .indent {
              padding-left: 1em;
            }
          `}
        >
          <h2>第１章 総則</h2>
          <h3>第１条（目的）</h3>
          <p>申込者/契約者（以下「甲」といいます。）とUniforce株式会社（以下「乙」といいます。）は、以下の利用規約（以下「本規約」といいます。）に基づき、乙が所持するクラウドサービス（以下総称して「本サービス」といいます。）の提供を実施いたします。</p>
          
          <h3>第２条（本規約の範囲）</h3>
          <p>本規約は、甲乙間の本サービスに関する一切の関係に適応されます。甲は本規約を確認し、同意した上で本サービスを申し込むものとし、本規約に則って本サービスを利用するものといたします。</p>
          
          <h3>第３条（本規約の変更）</h3>
          <ol className="i_2em">
            <li>１．乙は本サービスの内容を変更した場合等、甲の事前の承諾を得ることなく、本規約を随時変更することができるものといたします。また甲は本規約が変更された後の本サービス提供条件は、変更後の本規約に従うものといたします。</li>
            <li>２．乙は、前項の本規約の変更を行う場合は、変更後の本規約の効力発生時期を定め、効力発生時期の２週間前までに、変更後の本規約の内容及び効力発生時期をユーザーに通知、ウェブサイト上での表示その他乙所定の方法により甲に周知いたします。</li>
            <li>３．前項の規定にかかわらず、前項の本規約の変更の周知後に甲が本サービスを利用した場合又は乙所定の期間内に甲が解約の手続をとらなかった場合、甲は本規約の変更に同意したものといたします。</li>
            <li>４．「Uniforce利用契約申込書」（以下「利用申込書」といいます。）は、本規約と一体になるものとして適用されます。本規約または利用申込書の記載内容が相違するときには、その部分については利用申込書の記載内容を優先するものといたします。</li>
          </ol>
          
          <h3>第４条（用語の定義）</h3>
          <p>本規約において、用語の定義は次の通りといたします。</p>
          <ol className="i_3em">
            <li>（１）「お客様データ」とは、甲及び利用ユーザーが、または甲のために、本サービス上に保存される一切のデータを意味します。</li>
            <li>（２）「登録希望者」とは、本サービスへの申込を希望する法人、団体及び個人を意味します。</li>
            <li>（３）「本規約」とは、この「Uniforceサービス利用規約」を意味します。</li>
            <li>（４）「本規約等」とは、本規約及び第３７条に定める有効な付随規約等を意味します。</li>
            <li>（５）「本契約」とは、本規約等を契約条件として乙及び甲との間で締結される、本サービスの利用契約を指します。</li>
            <li>（６）「本サービス」とは、乙が提供するクラウドサービスならびにそれらに付随するサービス（サポートサービス、アップデート版サービス、サービス名称変更後の後継サービスも含みます）を意味します。</li>
            <li>（７）「利用ユーザー」とは、お客様の管理のもと、本サービスを利用するお客様の役員及び従業員、又はお客様の依頼する公認会計士、税理士、フィナンシャルアドバイザー等の外部専門家を意味します。</li>
            <li>（８）「サポートサービス」とは、乙が提供する、本サービスにかかわるサポート、アドバイザリー及びディレクションサービスを意味し、公認会計士、税理士等のコンサルタントのサポート・助言を含みます。</li>
          </ol>
          
          <h2>第２章 契約</h2>
          <h3>第５条（申込方法）</h3>
          <ol className="i_2em">
            <li>１．甲は、本規約の内容に同意の上、乙が定める手続きにより本サービスへの申込を行います。</li>
            <li>２．乙は、乙の基準に従い、前項に基づく本サービスへの申込につき承諾の可否を判断。乙が承諾する場合には、その旨を甲に通知し、この通知をもって、本契約が成立するものといたします。</li>
          </ol>
          
          <h2>第３章 甲の義務</h2>
          <h3>第６条（変更の届出）</h3>
          <ol className="i_2em">
            <li>１．甲は、乙に対し前項の申込時に通知した事項（以下「登録情報」といいます）に変更があった場合、乙の定める方法により当該変更事項を遅滞なく乙に通知するものといたします。</li>
            <li>２．乙は、甲が前項の通知を怠ったことにより、甲又は第三者が損害を被った場合であっても、一切責任を負わないものといたします。</li>
          </ol>
          
          <h3>第７条（禁止事項）</h3>
          <ol className="i_2em">
            <li>
              １．乙は、甲による本サービスの利用に際して、以下の各号に定める行為を禁止いたします。
              <ol className="i_3em">
                <li>（１）本規約に違反する行為</li>
                <li>（２）乙、乙がライセンスを受けているライセンサーその他第三者の知的財産権、特許権、実用新案権、意匠権、商標権、著作権、肖像権等の財産的又は人格的な権利を侵害する行為又はこれらを侵害する恐れのある行為</li>
                <li>（３）乙又は第三者に不利益若しくは損害を与える行為又はその恐れのある行為</li>
                <li>（４）不当に他人の名誉や権利、信用を傷つける行為又はその恐れのある行為</li>
                <li>（５）法令又は条例等に違反する行為</li>
                <li>（６）公序良俗に反する行為若しくはその恐れのある行為又は公序良俗に反する恐れのある情報を他の甲又は第三者に提供する行為</li>
                <li>（７）犯罪行為、犯罪行為に結びつく行為若しくはこれを助長する行為又はその恐れのある行為</li>
                <li>（８）事実に反する情報又は事実に反する恐れのある情報を提供する行為</li>
                <li>（９）乙のシステムへの不正アクセス、それに伴うプログラムコードの改ざん、位置情報の改ざん、故意に虚偽、通信機器の仕様その他アプリケーションを利用してのチート行為、コンピューターウィルスの頒布その他本サービスの正常な運営を妨げる行為又はその恐れのある行為</li>
                <li>（１０）本サービスの解析、分解、逆コンパイル、逆アセンブル、リバースエンジニアリング及びそれに類する行為</li>
                <li>（１１）本サービス及び乙コンテンツを、本サービスと同様又は類似のサービス、事業に使用する行為又は第三者をして使用させる行為</li>
                <li>（１２）本サービスの信用を損なう行為又はその恐れのある行為</li>
                <li>（１３）青少年の心身及びその健全な育成に悪影響を及ぼす恐れのある行為</li>
                <li>（１４）他の甲のアカウントの使用その他の方法により、第三者になりすまして本サービスを利用する行為</li>
                <li>（１５）詐欺、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく又は結びつく恐れのある行為</li>
                <li>（１６）犯罪収益に関する行為、テロ資金供与に関する行為又はその疑いがある行為</li>
                <li>（１７）乙に対して虚偽の情報（登録情報を含みます）を申告する行為</li>
                <li>（１８）その他乙が不適当と判断する行為</li>
              </ol>
            </li>
            <li>
              ２．乙は、甲の行為が、第１項各号のいずれかに該当すると判断した場合、事前に通知することなく、以下の各号のいずれか又は全ての措置を講じることができます。
              <ol className="i_3em">
                <li>（１）本サービスの利用制限</li>
                <li>（２）本契約の解除</li>
                <li>（３）その他乙が必要と合理的に判断する行為</li>
              </ol>
            </li>
          </ol>
          
          <h2>第４章 本サービス</h2>
          <h3>第８条（本アカウント）</h3>
          <ol className="i_2em">
            <li>１．乙は、本契約が成立した後、本サービス上にお客様用ページを作成し、当該お客様用ページにアクセスするためのID及びパスワード（以下「お客様アカウント」といいます）を乙に発行するものといたします。なお、乙は、前条の申込内容に基づく利用ユーザー数に応じて、利用ユーザーをお客様用ページに招待することができ、招待された利用ユーザーにはお客様用ページにアクセスするためのID及びパスワード（お客様アカウントと併せて「本アカウント」といいます）が発行されるものといたします。</li>
            <li>２．甲は、本アカウントが第三者に使用されるあるいは漏洩することがないよう厳重に管理するものといたします。</li>
            <li>３．甲は本アカウントを前第１項に定める利用ユーザー数を超えて利用することはできません。また、甲は、本アカウントを第三者に対して利用、貸与、譲渡、売買又は質入等をすることもできません。</li>
            <li>４．本アカウントの管理及び使用は、甲の責任で行うものとし、乙は、アカウントの漏洩、第三者による不正使用、使用上の過誤について、一切の責任を負わないものといたします。</li>
          </ol>
          
          <h3>第９条（最低利用期間）</h3>
          <ol className="i_2em">
            <li>１．本サービスの最低利用期間及び自動更新については利用申込書に定める期間いたします。なお、利用申込書に記載がない場合は１年といたします。なお最低利用期間後については、甲からの申し出がない限り１か月ごとの自動更新となります。</li>
            <li>２．甲が最低利用期間内に本契約の解約を希望する場合、解約を希望する日（以下「解約日」といいます）の１ヵ月前までに、口頭またはメール等メッセージツールにより、その旨を乙に通知するものといたします。</li>
            <li>３．前項に該当する場合、甲は乙に対し、解約日が属する月の末日までに、最低利用期間満了日までの残余の期間に対応する利用料金（消費税含む）を一括して支払うものといたします。</li>
          </ol>
          
          <h3>第１０条（本サービスの利用）</h3>
          <p>
            甲は、本サービスを甲自身の業務のためにのみ利用することができます。甲は、本サービスを第三者に販売することその他商業目的で使用することはできません。
          </p>
          
          <h3>第１１条（サポートサービス）</h3>
          <ol className="i_2em">
            <li>
              １．甲が第５条第１項に基づきサポートサービスの利用を申込み、乙が同条第２項に基づきその利用を承諾した場合、乙は甲に対し、当該申込時に甲に提示した内容に従い、サポートサービスを提供いたします。なおサポートサービスの基本内容は以下の各号とし、プランごとの詳細については利用申込書に定めるものといたします。
              <ol className="i_3em">
                <li>（１）初回オンボーディング</li>
                <li>（２）メール/クラウド内からの問い合わせ対応</li>
              </ol>
            </li>
            <li>２．甲は、乙からの要請に応じて、サポートサービスの遂行に必要な資料、情報等（以下「資料等」という）をその責任と費用負担により乙に適時に提供するものといたします。資料等の提供不足や遅延、資料等の誤り等により甲に損害が生じたとしても、乙は一切の責任を負いません。また、公認会計士、税理士等のコンサルタントのサポート・助言に関し、その用途から生じる結果や信頼性に起因する問題等については乙の責任範囲外といたします。</li>
            <li>３．乙は、甲の資料等を、甲の秘密情報として第２９条に従い取り扱うものといたします。</li>
          </ol>
          
          <h2>第５章 利用料金</h2>
          <h3>第１２条（利用料金）</h3>
          <ol className="i_2em">
            <li>１．甲は、本サービスの利用料金を、利用申込書に定める算定方式および支払条件に基づいて、乙に支払うものといたします。なお、本サービスが無償で提供される場合、甲が本サービスを利用している期間中、ご利用状況に応じて双方の合意のもと有償での提供に切り替わることがございます。</li>
            <li>２．甲は利用料金を、本サービスを開始した日に属する月、及びそれ以降の各暦月について支払うものといたします。但し、本サービスを開始した日が含まれる月に関しては、サービス開始日からの利用日数及び暦日数に応じて日割り計算が行われないものといたします。</li>
          </ol>
          
          <h3>第１３条（料金等の支払義務）</h3>
          <ol className="i_2em">
            <li>１．甲は、第１２条の料金を支払う義務を負います。</li>
            <li>２．第２３条の規定により本サービスの提供が停止された場合であっても、本サービスの料金の算出については、当該サービスの提供があったものとして取り扱います。</li>
          </ol>
          
          <h3>第１４条（料金等の支払方法）</h3>
          <p>
            別途の定めがない限り、甲は乙に対して当月分の本サービス利用料金を翌月末日までに、乙が別途指定する銀行口座に振り込む方法で支払うものといたします。支払いに関する細部条項は甲と収納代行会社、金融機関等との契約条項または乙が指定する期日、方法によります。なお、甲と収納代行会社、金融機関等の間で紛争が発生した場合は、当該当事業者双方で解決するものといたします。
          </p>

          <h3>第１５条（延滞損害金）</h3>
          <ol className="i_2em">
            <li>１．甲が、料金その他の債務について支払期日を経過してもなお支払がない場合、支払期日の翌日から支払の日の前日までの日数について、年14.6％の割合で計算して得た額を、延滞損害金として乙が指定する期日までに支払うことといたします。</li>
            <li>２．支払いについては、乙が指定する方法により支払うものといたします。</li>
          </ol>
          
          <h3>第１６条（消費税）</h3>
          <p>
            甲が乙に対し本サービスに関わる債務を支払う場合において、消費税法および同法に関する法令の規程により当該支払について消費税および地方消費税が賦課されるものとされているときは、甲は乙に対し当該債務を支払う際に、これに対する消費税および地方消費税相当額を併せて支払うものといたします。
          </p>

          <h3>第１７条（端数処理）</h3>
          <p>
            乙は料金その他の計算において、その計算結果に１円未満の端数が生じた場合は、その端数を切り捨てます。
          </p>
          
          <h2>第６章 利用環境</h2>
          <h3>第１８条（本サービス環境の管理）</h3>
          <ol className="i_2em">
            <li>１．甲は、本サービスの提供を受けるために必要な機器、通信手段及び交通手段等の環境（以下「本サービス環境」といいます）を全て自らの費用と責任で備えます。また、本サービスの利用にあたり必要となる通信費用は、全て甲の負担といたします。</li>
            <li>２．甲は、本サービス環境の管理責任を負います。本サービス環境の管理不十分、使用上の過誤、第三者の使用等による損害の責任は甲が負い、乙は一切の責任を負わないものといたします。</li>
          </ol>
          
          <h3>第１９条（第三者サービスとの連携）</h3>
          <ol className="i_2em">
            <li>１．本サービスにおいて、第三者が提供する無償または有償のサービスまたはソフトウェア（以下、「第三者サービス」）と連携することによって実現される機能（以下、「第三者サービス連携機能」といいます）が提供される場合があります。この場合、甲は、甲の費用と責任において、第三者サービスの本規約等に同意のうえで、第三者サービス及び第三者サービス連携機能を利用するものといたします。</li>
            <li>２．乙は、甲による第三者サービス及び第三者サービス連携機能の利用について、一切の責任を負わないものといたします。</li>
            <li>３．乙は、乙の裁量により、甲への通知なく、第三者サービス連携機能の変更及び提供の中断又は終了する場合があります。かかる変更及び中断または終了を行なった場合であっても、乙は一切の責任を負わないものといたします。</li>
          </ol>
          
          <h3>第２０条（お客様データ）</h3>
          <ol className="i_2em">
            <li>１．甲は、自己の責任でお客様データのバックアップを行うものといたします。乙は、お客様データの消失、削除等につき一切の責任を負いません。</li>
            <li>２．乙は、本サービスの提供、改良及び保守並びに甲へのサポート対応（お問合せ対応を含む）に合理的に必要な範囲で、お客様データを利用することができます。また、乙は、お客様データを統計処理したうえで、個人が特定できないかたちで、マーケティングその他乙事業目的に使用し又は第三者に提供することがあります。</li>
            <li>３．甲は乙に対し、乙が第三者サービス連携機能を利用するに必要な範囲で、第三者サービス提供者に対し、お客様データを提供することを許諾いたします。</li>
            <li>４．乙は、本契約が終了した後もお客様データを保持することができるものといたします。ただし、甲からお客様データ削除の要請があった場合、乙は、当該要請にってお客様データを削除するものといたします。このとき、乙は、お客様データの削除につき、一切の責任を負わないものといたします。</li>
          </ol>
          
          <h2>第７章 サービスの停止・中止等</h2>
          <h3>第２１条（本サービスの停止又は中断）</h3>
          <ol className="i_2em">
            <li>
              １．乙は以下のいずれかに該当する場合には、甲に事前に通知することなく、本サービスの全部又は一部の提供を停止又は中断できるものといたします。
              <ol className="i_3em">
                <li>（１）本サービスの提供に必要なシステムの点検又は保守作業を行う場合</li>
                <li>（２）本サービスの提供に必要なシステム及び通信回線等が停止した場合</li>
                <li>（３）本サービスの提供に必要な外部システムの提供又は利用が中断された場合</li>
                <li>（４）地震、落雷、火災、風水害、停電、疾病の蔓延、天災地変等の不可抗力により、本サービスの運営が困難となった場合</li>
                <li>（５）その他、乙が合理的理由に基づき停止又は中断を必要と判断した場合</li>
              </ol>
            </li>
            <li>２．乙は前項に定める事由において本サービスを提供できなかったことに関して、甲またはその他の第三者が損害を被った場合であっても、一切の責任を負わないものといたします。</li>
          </ol>
          
          <h3>第２２条（本サービスの廃止）</h3>
          <p>乙は、乙が本サービスの提供を廃止すべきと合理的に判断した場合、本サービスの提供を廃止できます。なお、乙は、本サービスの廃止について、一切の責任を負いません。</p>
          
          <h2>第８章 契約の解除/解約及び変更</h2>
          <h3>第２３条（乙による本契約の解除）</h3>
          <ol className="i_2em">
            <li>１．乙は、甲が、本サービスの利用料金について、支払期日を２ヵ月経過してもなお支払われないときは、本契約を解除することができます。</li>
            <li>２．乙は、前項の規定により本契約を解除しようとするときには、あらかじめその旨を甲に通知いたします。</li>
            <li>
              ３．乙は、甲が以下の各号のいずれかに該当した場合、何らの通知等を要することなく、本契約を解除することができます。
              <ol className="i_3em">
                <li>（１）登録情報に虚偽の情報が含まれている場合</li>
                <li>（２）未成年が法定代理人の同意なく、本サービスを利用した場合</li>
                <li>（３）成年被後見人、被保佐人又は被補助人が、成年後見人、保佐人又は補助人等の同意なく、本サービスを利用した場合</li>
                <li>（４）乙からの要請に対し誠実に対応しない場合</li>
                <li>（５）その他乙が不適当と判断した場合</li>
              </ol>
            </li>
            <li>４．前項に基づき本契約が解約された甲は、解約時に期限の利益を喪失し、直ちに、乙に対し負担する全ての債務を履行いたします。</li>
          </ol>

          <h3>第２４条（甲による本契約の解約および変更）</h3>
          <ol className="i_2em">
            <li>１．甲は、本契約の一部または全部を解約および変更しようとするときは、解約日および契約の変更日希望日の１ヵ月前までに、口頭またはメール等メッセージツールにより、その旨を乙に通知するものといたします。</li>
            <li>２．甲及び乙は、前項の通知のうえで双方の合意のもと、書面（電子的方法による電磁的記録を含む）によって本契約の一部または全部を解約又は変更することができるものとする。</li>
            <li>３．解約を希望する場合、甲は乙に対して解約日を含む利用期間の利用料金を、解約日の翌月末までに支払うものといたします。</li>
            <li>４．解約されたサービスに該当する利用料金がすでに支払われている場合は、乙は甲に対して未経過期間に対する金額を返却しないものといたします。</li>
          </ol>

          <h2>第９章 損害賠償</h2>
          <h3>第２５条（非保証・免責）</h3>
          <ol className="i_2em">
            <li>１．乙は、本サービスの内容、使用結果、的確性、特定目的との適合性、機能の実現性、お客様データを含むデータの送受信エラー及びバックアップ、バグその他瑕疵の不存在、契約不適合責任、および第三者の知的財産権の非侵害に関する保証を含め、本サービスに関して一切の保証をいたしません。また、乙は、本サービスに中断、中止その他の障害が生じないことを保証しません。</li>
            <li>２．甲は、法令の範囲内で本サービスをご利用ください。本サービスの利用に関連して甲が日本又は外国の法令に触れた場合でも、乙は一切の責任を負いません。</li>
            <li>３．本サービスは、甲又は利用ユーザーご自身で実施する決算開示、上場準備その他の業務の管理を支援するためのサービスであり、甲は、本サービスを通じて取得した情報について、自らの判断及び責任において必要に応じ利用するものといたします。</li>
            <li>４．予期しない不正アクセス等の行為によってお客様データを含む甲にかかる情報を盗取された場合でも、それによって生じる甲の損害等に対して、乙は一切の責任を負いません。</li>
            <li>５．乙は、天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本契約の全部又は一部に不履行が発生した場合、一切の責任を負いません。</li>
            <li>６．本サービスの利用に関し、甲が第三者との間でトラブル（本サービス内外を問いません。）になった場合でも、乙は一切の責任を負わず、当該トラブルは、甲が自らの責任と費用において解決するものといたします。</li>
          </ol>
          
          <h3>第２６条（損害賠償責任）</h3>
          <ol className="i_2em">
            <li>１．甲は、本規約の違反又は本サービスの利用に関連して乙に損害を与えた場合、乙に発生した損害（逸失利益及び弁護士費用を含みます。）を賠償いたします。</li>
            <li>２．本サービス及び本契約に関して乙が甲に対して負う損害賠償額の総額は、請求原因の如何を問わず、損害発生日から直近1年間の利用料金の累積総額（累積総額がゼロ円の場合は金１万円）を上限といたします。</li>
          </ol>
          
          <h2>第１０章 秘密保持</h2>
          <h3>第２７条（秘密保持）</h3>
          <ol className="i_2em">
            <li>１．甲及び乙は、本サービスの提供に関して知り得た相手方の秘密情報（本サービスに関するノウハウ、乙のシステムに関する情報、技術上又は営業上の一切の秘密情報を含みます。）を、厳重かつ適正に管理するものとし、相手方の事前の書面による同意なく第三者（乙の関連会社及び委託先を含みます。）に開示、提供及び漏洩しないものといたします。</li>
            <li>
              ２．次の各号の情報は、秘密情報に該当しないものといたします。
              <ol className="i_3em">
                <li>（１）開示を受けた時、既に所有していた情報</li>
                <li>（２）開示を受けた時、既に公知であった情報又はその後自己の責に帰さない事由により公知となった情報</li>
                <li>（３）開示を受けた後に、第三者から合法的に取得した情報</li>
                <li>（４）開示された秘密情報によらず独自に開発し又は創作した情報</li>
              </ol>
            </li>
            <li>３．前項にかかわらず、甲及び乙は、法令、裁判所、行政庁又は規制権限を有する公的機関の規則、裁判、命令、指示等により相手方の秘密情報の開示を要求される場合、必要な範囲で秘密情報を公開又は開示することができるものといたします。但し、甲及び乙は、当該公開又は開示を行う場合には、可能な場合は事前に、不可能又は著しく困難な場合は事後遅滞なく、その旨を相手方に対して通知するものといたします。</li>
            <li>４．甲及び乙は、相手方の指示があった場合又は本契約が終了した場合は、相手方の指示に従い速やかに秘密情報を、原状に回復した上で返却又は廃棄し、以後使用しないものといたします。</li>
            <li>５．甲及び乙は、本サービスを提供、利用するのに必要な範囲で、相手方の秘密情報を利用することができます。</li>
          </ol>
          

          <h2>第１１ 章雑則</h2>
          <h3>第２８条（知的財産権等）</h3>
          <p>
            方法又は形態の如何を問わず、本サービスにおいて提供される全ての情報及びコンテンツ及び本サービスに関する著作権、特許権、実用新案権、商標権、意匠権その他一切の知的財産権及びこれらの権利の登録を受ける権利（以下総称して「知的財産権」といいます）は、乙又は乙がライセンスを受けているライセンサーに帰属し、甲には帰属しません。
          </p>
          
          <h3>第２９条（個人情報）</h3>
          <p>
            甲は、乙が、乙に対して甲が提供する個人情報を、乙が別途定めるプライバシーポリシー（乙のウェブサイトに掲載）に従って取り扱うことに同意いたします。
          </p>
          
          <h3>第３０条（反社会的勢力の排除）</h3>
          <ol className="i_2em">
            <li>
              １．甲及び乙は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下総称して「暴力団員等」といいます）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証いたします。
              <ol className="i_3em">
                <li>（１）暴力団員等が経営を支配していると認められる関係を有すること</li>
                <li>（２）暴力団員等が経営に実質的に関与していると認められる関係を有すること</li>
                <li>（３）自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に暴力団員等を利用していると認められる関係を有すること</li>
                <li>（４）暴力団員等に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること</li>
                <li>（５）役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること</li>
              </ol>
            </li>
            <li>
              ２．甲及び乙は、自ら又は第三者を利用して次の各号のいずれにも該当する行為を行わないことを確約いたします。
              <ol className="i_3em">
                <li>（１）暴力的な要求行為</li>
                <li>（２）法的な責任を超えた不当な要求行為</li>
                <li>（３）取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
                <li>（４）風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為</li>
                <li>（５）その他前各号に準ずる行為</li>
              </ol>
            </li>
            <li>３．甲及び乙は、相手方が、暴力団員等若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規定にもとづく表明・保証に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、相手方に対して何らの催告をすることなく本契約を解除することができます。</li>
            <li>４．甲及び乙は、前項により本契約を解除した場合、相手方に損害が生じたとしてもこれを一切賠償する責任はないことを確認し、これを了承いたします。</li>
          </ol>
          
          <h3>第３１条（お問い合わせ対応）</h3>
          <ol className="i_2em">
            <li>１．乙は、本サービスに関する甲からのお問い合わせに対して回答するよう努めますが、法令又は本規約上、乙に義務又は責任が発生する場合を除き、回答の義務を負いません。</li>
            <li>２．乙は、甲からのお問い合わせに回答するか否かの基準を開示する義務を負いません。</li>
          </ol>
          
          <h3>第３２条（地位の譲渡等）</h3>
          <p>
            甲及び乙は、相手方の書面による事前の承諾なく、本契約上の地位又は本規約に基づく権利若しくは義務の全部又は一部につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。但し、株式譲渡若しくは事業譲渡又は合併、会社分割その他の組織再編についてはこの限りではありません。
          </p>
          
           <h3>第３３条（分離可能性）</h3>
          <ol className="i_2em">
            <li>１．本規約の規定の一部が法令に基づいて無効と判断されても、本規約の他の規定は有効といたします。</li>
            <li>２．本規約の規定の一部がある甲との関係で無効又は取消となった場合でも、本規約は他の甲との関係では有効といたします。</li>
          </ol>
          
          <h3>第３４条（違反行為への対処方法）</h3>
          <ol className="i_2em">
            <li>１．甲は、本規約に違反する行為を発見した場合は、乙にご連絡ください。</li>
            <li>２．甲は、本規約に違反する行為への乙の対処について、異議を申し立てることはできません。</li>
          </ol>

          <h3>第３５条（準拠法）</h3>
          <p>
            本規約に関する準拠法は、全て日本国の法令が適用されます。
          </p>

          <h3>第３６条（合意管轄）</h3>
          <p>
            甲と乙との間における一切の訴訟は、東京地方裁判所を第一審の専属的合意管轄裁判所といたします。
          </p>

          <h3>第３７条（その他）</h3>
          <ol className="i_2em">
            <li>１．甲は、本規約に定めのない事項について、乙が本サービスの本規約、細則等（以下「付随規約等」といいます）を別途定めた場合、これに従います。</li>
            <li>２．付随規約等は、付随規約等に別途の定めがない限り、乙所定の箇所に掲載した時点より効力を生じます。</li>
            <li>３．付随規約等と本規約の内容に矛盾抵触がある場合、本規約が優先いたします。</li>
          </ol>
          
          <p
            css={css`
              width: max-content;
              margin-top: 32px;
              margin-left: auto;

              @media ${getScreen('pc')} {
                margin-top: 40px;
              }
            `}
          >
            ２０２２年３月２６日：制定・施行<br />
            ２０２２年１１月４日：改定<br />
            ２０２４年１２月１８日：改定<br />
            ２０２５年２月２５日：改定
          </p>
        </div>
      </div>
    </section>
    <ContactSection
      css={css`
        margin-top: 80px;

        @media ${getScreen('pc')} {
          margin-top: 96px;
        }
      `}
      title1="Uniforce IPO準備クラウドで"
      title2="「IPOの準備を効率的」"
      title3="に"
      title4="進めませんか？"
      text="IPO準備クラウドの機能詳細や無料デモのご相談はこちら"
    />
  </Layout>
);

export default Page;
